import { ActivityLogCard } from '#components/organisms/dataDisplay/ActivityLog/ActivityLogCard';
import { LogActivityModal } from '#components/organisms/modals/LogActivityModal/LogActivityModal';
import {
  LogActivityModalFlow,
  useLogActivityModalProvider,
} from '#components/organisms/modals/LogActivityModal/LogActivityModalFlow';
import { LogActivitySuccessModal } from '#components/organisms/modals/LogActivityModal/LogActivitySuccessModal';
import { PeerParticipant } from '@givebacks/api/store';
import { FormListProviderWrapper } from 'core';

const ActivityLogWrapper = ({ participant }: { participant: PeerParticipant }) => {
  const { openModalById, meta } = useLogActivityModalProvider({});

  return (
    <ActivityLogCard
      participant={participant}
      onClick={() => openModalById('base')}
      unitsOfActivity={meta?.unitsOfActivity}
    />
  );
};

const ActivityLog = ({
  participant,
  onSuccess,
}: {
  participant: PeerParticipant;
  onSuccess?: () => void;
}) => {
  return (
    <FormListProviderWrapper>
      <LogActivityModalFlow participant={participant} onSuccess={onSuccess}>
        <ActivityLogWrapper participant={participant} />
        <LogActivityModal />
        <LogActivitySuccessModal />
      </LogActivityModalFlow>
    </FormListProviderWrapper>
  );
};

export { ActivityLog };
